import React, { useEffect, useRef, useState } from "react"
import "./styles.scss"
import { Link } from "gatsby"
import classnames from "classnames"

export enum PAGES {
  FEATURED,
  OBJECTS,
  SHOP_THE_FEED,
  ABOUT,
  STOCKISTS,
}

export const routes = [
  {
    title: "FEATURED",
    page: PAGES.FEATURED,
    path: "/",
  },
  {
    title: "OBJECTS",
    page: PAGES.OBJECTS,
    path: "/objects",
  },
  {
    title: "SHOP THE FEED",
    page: PAGES.SHOP_THE_FEED,
    path: "/shop-the-feed",
  },
  {
    title: "ABOUT",
    page: PAGES.ABOUT,
    path: "/about",
  },
  {
    title: "STOCKISTS",
    page: PAGES.STOCKISTS,
    path: "/stockists",
  },
]

const foundRoute = (route, location) => {
  return route.path === location?.pathname
    || (location?.pathname?.startsWith(route.path) && route.path !== "/")
    || (location?.pathname?.startsWith('/looks') && route.path === '/shop-the-feed')
}

export const getCurrentRouteIndex = (location) => {
  return routes.findIndex(r => foundRoute(r, location))
}

const Nav = ({ location }: { location: { pathname: string }}) => {
  const [navWidth, setNavWidth] = useState(0)
  const [linksTransition, setLinksTransition] = useState(false)

  const currentRoute = routes.find(r => foundRoute(r, location))
  const currentRouteIndex = routes.findIndex(r => foundRoute(r, location))

  const navContainerRef = useRef()

  useEffect(() => {
    const handleResize = () => {
      if (navContainerRef.current) {
        const { width } = navContainerRef.current.parentElement.getBoundingClientRect()
        setNavWidth(width)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [navContainerRef])

  useEffect(() => {
    const linksTransitionTimeout = setTimeout(() => {
      setLinksTransition(true)
    }, 300);

    return () => {
      clearTimeout(linksTransitionTimeout)
    }
  }, [navWidth])

  return (
    <div
      ref={navContainerRef}
      className="hidden z-40 mt-14 md:flex md:w-full md:flex-row md:fixed md:bg-black lg:bg-transparent md:border-b lg:border-0 border-white pointer-events-none"
      style={{
        ["--navWidth" as any]: `${navWidth}px`
      }}
    >
      <div
        className="hidden md:flex flex-1 lg:hidden items-center justify-center"
      >{typeof window !== "undefined" && (new Date()).toLocaleTimeString("en-us", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })}</div>
      <nav className={classnames("z-40 hidden lg:w-full md:flex md:top-14", {
        "border-r": !currentRoute
      })}>
        {routes.map((route, routeIndex) => {
          const currentlyActive = route.path === location?.pathname
          || (route.path === '/shop-the-feed' && location?.pathname.startsWith('/looks'))

          const leftOfActive = routeIndex <= currentRouteIndex || currentRouteIndex === -1

          let borderLClass = "border-l"
          let borderRClass = ""

          if (routeIndex === 0) {
            borderLClass = "border-l lg:border-0 xl:border-l"
          }

          if (currentRouteIndex === -1) {
            borderRClass = "border-r lg:border-0 xl:border-r"
          }

          return (
            <Link
              key={route.path}
              to={route.path}
              className={classnames(`nav-link hidden pointer-events-auto lg:h-full ${borderLClass} ${borderRClass} border-white h2-universal`, {
                "bg-black": !currentlyActive,
                "hover:bg-white": !currentlyActive,
                "hover:text-black": !currentlyActive,
                "left-transform": currentlyActive || leftOfActive,
                "right-transform": !leftOfActive && !!currentRoute,
                "has-transition": linksTransition,
                "is-active": currentlyActive,
                "md:flex": navWidth,
              })}
              partiallyActive={route.page !== PAGES.FEATURED}
              state={{ reverseAnimation: leftOfActive }}
            >
              {route.title}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}

export default Nav
